import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers/DatePicker';
import { formatISO, isValid, parseISO } from 'date-fns';
import React from 'react';
export const DatePicker = (props) => {
    var _a;
    const [focused, setFocused] = React.useState(false);
    let value;
    const dateRangeProps = {};
    if (props.value.invalidDate) {
        value = props.value.invalidDate;
    }
    else if (props.value.date != null) {
        value = parseISO(props.value.date);
    }
    else {
        value = null;
    }
    let minDate;
    if (props.minDate) {
        minDate = parseISO(props.minDate);
        if (!isValid(minDate)) {
            minDate = undefined;
        }
    }
    let maxDate;
    if (props.maxDate) {
        maxDate = parseISO(props.maxDate);
        if (!isValid(maxDate)) {
            maxDate = undefined;
        }
    }
    if (minDate) {
        dateRangeProps.minDate = minDate;
    }
    if (maxDate) {
        dateRangeProps.maxDate = maxDate;
    }
    return (React.createElement(MuiDatePicker, Object.assign({ label: (value != null || focused) && props.hideLabel ? '' : props.label, value: value, disabled: props.disabled, readOnly: props.readOnly }, (Object.keys(dateRangeProps).length > 0 ? dateRangeProps : {}), { slotProps: {
            textField: {
                onFocus: () => {
                    setFocused(true);
                },
                onBlur: () => {
                    setFocused(false);
                },
                fullWidth: props.fullWidth,
                error: props.error,
                required: props.required,
                size: props.size,
                autoComplete: 'off',
                tabIndex: props.tabIndex,
                InputLabelProps: !props.hideLabel ? undefined : { shrink: false },
                inputProps: { 'aria-label': props.label, 'aria-describedby': props.ariaDescribedBy },
                sx: Object.assign({ width: '100%', maxWidth: {
                        xs: '100%',
                        sm: props.fullWidth ? '100%' : 260,
                    }, '& label.MuiInputLabel-root': { paddingRight: 3 } }, props.sx),
                autoFocus: (_a = props.autoFocus) !== null && _a !== void 0 ? _a : false,
            },
        }, onChange: (newDate) => {
            if (newDate != null) {
                if (isValid(newDate)) {
                    props.onChange({ date: formatISO(newDate, { representation: 'date' }) });
                }
                else {
                    props.onChange({ invalidDate: newDate });
                }
            }
            else {
                props.onChange({});
            }
        } })));
};
